import { BurgerButton } from "./BurgerButton";
import {
  StyledBottom,
  StyledButtons,
  StyledButtonsSecondary,
  StyledDownDesktopHeader,
  StyledLogoContainer,
  StyledMainNavigation,
  StyledSearchInput,
  StyledSearchInputContainer,
  StyledTop,
} from "./styles";

import { Logo } from "../Logo";

import { Container } from "@layouts/MainLayout/Container";
import { useDisableBodyScroll } from "@packages/uiKit/hooks";
import React, { FC, memo, useCallback, useState } from "react";

import { CurrencySelector } from "../CurrencySelector";

import { useRouter } from "next/router";
import { CityButtonAdapter } from "../CityButtonAdapter";
import { LanguageSelector } from "../LanguageSelector";
import { SecondaryNavigation } from "../SecondaryNavigation";

interface MobileHeaderProps {
  className?: string;
  style?: React.CSSProperties;
}

const _MobileHeader: FC<MobileHeaderProps> = (props) => {
  const { ...restProps } = props;

  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();

  const isMainPage = router.asPath === "/";

  useDisableBodyScroll(isOpen);

  const burgerClickHandler = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const navigateHandler = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <StyledDownDesktopHeader $isOpen={isOpen} {...restProps}>
      <Container>
        <StyledTop>
          <StyledLogoContainer>
            <Logo />
          </StyledLogoContainer>

          <StyledButtons>
            <CityButtonAdapter />
            <StyledButtonsSecondary>
              <CurrencySelector />
              <LanguageSelector />
            </StyledButtonsSecondary>
          </StyledButtons>
        </StyledTop>

        <StyledBottom>
          <StyledSearchInputContainer>
            <StyledSearchInput />
          </StyledSearchInputContainer>

          <BurgerButton isOpen={isOpen} onClick={burgerClickHandler} />
        </StyledBottom>
        {isMainPage && <StyledMainNavigation $isOpen={isOpen} />}

        {isOpen && <SecondaryNavigation onNavigate={navigateHandler} />}
      </Container>
    </StyledDownDesktopHeader>
  );
};

export const MobileHeader = memo(_MobileHeader);
